export const PercentDisplayFormat = "0.[0]%";

export enum PercentFormat {
  Decimal = "decimal",
  Percentage = "percentage",
}
